// Auto-suggests the camera framing/angle from the uploaded subject reference.
// When the operator picks an input picture, posts it to analyze_camera_shot
// and pre-selects the matching option in the camera-shot <select> — but ONLY
// when the operator hasn't already chosen one (an explicit pick always wins).
// Selecting the option dispatches a change event so the prompt regenerates.
//
// Markup expected:
//   <div data-controller="camera-suggest"
//        data-camera-suggest-endpoint-value="<%= analyze_camera_shot_... %>">
//     <select data-camera-suggest-target="select" ...>…</select>
//     <span data-camera-suggest-target="status" hidden></span>
//     ... reference file inputs with data-action="change->camera-suggest#analyze" ...
//   </div>
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "status"]
  static values = { endpoint: String }

  analyze(event) {
    const input = event.target
    const file = input && input.files && input.files[0]
    if (!file || !this.hasSelectTarget || !this.endpointValue) return
    // Respect an explicit operator choice — never overwrite it.
    if (this.selectTarget.value) return

    this._status("Reading framing from the reference…")

    const fd = new FormData()
    fd.append("file", file)
    const csrf = document.querySelector('meta[name="csrf-token"]')
    const headers = csrf ? { "X-CSRF-Token": csrf.content } : {}

    fetch(this.endpointValue, { method: "POST", headers, body: fd, credentials: "same-origin" })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}))
        if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`)
        return data
      })
      .then((data) => {
        // Re-check: operator may have picked while we were waiting.
        if (data.camera_shot && !this.selectTarget.value) {
          this.selectTarget.value = data.camera_shot
          this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
          this._status(`Suggested: ${data.label || data.camera_shot} — change it or reset to Auto.`)
        } else {
          this._status("")
        }
      })
      .catch(() => this._status(""))
  }

  _status(text) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = text
    this.statusTarget.hidden = !text
  }
}
